import { Calendar, Trophy, Award, User } from 'lucide-react';
import { defineSchema, CANONICAL_CHAMPIONSHIPS, CANONICAL_CATEGORIES } from '@shared/search';

export const trackRaceEventsSchema = defineSchema({
  id: 'track-race-events',
  title: 'filter.schema.trackRaceEvents.title',
  subtitle: 'filter.schema.trackRaceEvents.subtitle',
  defaultField: 'championship',
  fields: {
    season: {
      key: 'season',
      label: 'filter.field.season',
      type: 'number',
      icon: Calendar,
      description: 'filter.desc.season',
      example: 'season:2026',
      presets: [
        { label: '2026', value: '2026', operator: '=' },
        { label: '2025', value: '2025', operator: '=' },
        { label: '2024', value: '2024', operator: '=' },
      ],
    },
    championship: {
      key: 'championship',
      label: 'filter.field.championship',
      type: 'enum',
      icon: Trophy,
      allowMultiple: true,
      description: 'filter.desc.championship',
      options: CANONICAL_CHAMPIONSHIPS,
      example: 'championship:RMC',
    },
    category: {
      key: 'category',
      label: 'filter.field.category',
      type: 'enum',
      icon: Award,
      allowMultiple: true,
      description: 'filter.desc.category',
      options: CANONICAL_CATEGORIES,
      example: 'category:Max',
    },
    driver: {
      key: 'driver',
      label: 'filter.field.driver',
      type: 'text',
      icon: User,
      placeholder: 'filter.placeholder.driver',
      description: 'filter.desc.driverEvent',
      example: 'driver:Yanick',
    },
    from: {
      key: 'from',
      label: 'filter.field.date',
      type: 'dateRange',
      icon: Calendar,
      description: 'filter.desc.date',
      example: 'from:-1y',
      datePresets: [
        { label: 'filter.preset.today', value: 'today' },
        { label: 'filter.preset.last30d', value: '-30d' },
        { label: 'filter.preset.last90d', value: '-90d' },
        { label: 'filter.preset.last1y', value: '-1y' },
      ],
    },
  },
  examples: [
    { q: 'championship:RMC season:2026', desc: 'filter.example.rmc2026' },
    { q: 'driver:Yanick season:2025', desc: 'filter.example.yanick2025' },
    { q: 'category:"DD2" from:-1y', desc: 'filter.example.dd2Last1y' },
  ],
});

